export default {
  message: {
    hello: 'こんにちは、世界'
  }
}
